module.exports = __webpack_public_path__ + "static/media/nynfc3.a4054eda.jpg";